import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEllipsis = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 19 19",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M4.75 11.083a1.583 1.583 0 1 0 0-3.166 1.583 1.583 0 0 0 0 3.166m4.75 0a1.583 1.583 0 1 0 0-3.166 1.583 1.583 0 0 0 0 3.166m4.75 0a1.583 1.583 0 1 0 0-3.166 1.583 1.583 0 0 0 0 3.166",
		clipRule: "evenodd",
		opacity: .8
	})
});
export default SvgEllipsis;
